module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_8004.12e18e6a.png";